import { blinkConstants } from '@thoughtspot/blink-constants';
import { arrayOf, HostEventContexts, objectOf, oneOf, optional, optionalArrayOf, optionalObjectOf, required, requiredArrayOf, voidParam, } from '../host-event-schema';
var HomePageSearchBarMode;
(function (HomePageSearchBarMode) {
    HomePageSearchBarMode["OBJECT_SEARCH"] = "objectSearch";
    HomePageSearchBarMode["AI_ANSWER"] = "aiAnswer";
    HomePageSearchBarMode["NONE"] = "none";
})(HomePageSearchBarMode || (HomePageSearchBarMode = {}));
var EmbedEventConstants;
(function (EmbedEventConstants) {
    EmbedEventConstants["Status"] = "status";
})(EmbedEventConstants || (EmbedEventConstants = {}));
var IncomingEventType;
(function (IncomingEventType) {
    IncomingEventType["Drilldown"] = "triggerDrillDown";
    IncomingEventType["Search"] = "search";
    IncomingEventType["SetVisibleVizs"] = "SetPinboardVisibleVizs";
    IncomingEventType["SetVisibleTabs"] = "SetPinboardVisibleTabs";
    IncomingEventType["SetHiddenTabs"] = "SetPinboardHiddenTabs";
    IncomingEventType["UpdateRuntimeFilters"] = "UpdateRuntimeFilters";
    IncomingEventType["Refresh"] = "refresh";
    IncomingEventType["GetTML"] = "getTML";
    IncomingEventType["GetAnswerSession"] = "getAnswerSession";
    IncomingEventType["ResetSearch"] = "resetSearch";
    IncomingEventType["OpenFilter"] = "openFilter";
    IncomingEventType["OpenAddFilterModal"] = "openAddFilterModal";
    IncomingEventType["OpenAddParameterModal"] = "openAddParameterModal";
    IncomingEventType["AddColumns"] = "addColumns";
    IncomingEventType["RemoveColumn"] = "removeColumn";
    IncomingEventType["Navigate"] = "Navigate";
    IncomingEventType["GetFilters"] = "getFilters";
    IncomingEventType["UpdateFilters"] = "updateFilters";
    IncomingEventType["GetTabs"] = "getTabs";
    IncomingEventType["UpdateCrossFilter"] = "UpdateCrossFilter";
    IncomingEventType["ResetLiveboardPersonalisedView"] = "ResetLiveboardPersonalisedView";
    IncomingEventType["UpdateSageQuery"] = "updateSageQuery";
    IncomingEventType["AskSage"] = "AskSage";
    IncomingEventType["GetParameters"] = "GetParameters";
    IncomingEventType["UpdateParameters"] = "UpdateParameters";
    IncomingEventType["GetIframeUrl"] = "GetIframeUrl";
    IncomingEventType["UiPassthrough"] = "UiPassthrough";
    IncomingEventType["UpdatePersonalisedView"] = "UpdatePersonalisedView";
    IncomingEventType["SelectPersonalisedView"] = "SelectPersonalisedView";
    IncomingEventType["SetTokenGenerationConfig"] = "SetTokenGenerationConfig";
    IncomingEventType["TransformTableVizData"] = "TransformTableVizData";
    IncomingEventType["InfoSuccess"] = "InfoSuccess";
    IncomingEventType["UpdateCustomCss"] = "UpdateCustomCss";
    IncomingEventType["SpotterSearch"] = "SpotterSearch";
    IncomingEventType["EditLastPrompt"] = "EditLastPrompt";
    IncomingEventType["PreviewSpotterData"] = "PreviewSpotterData";
    IncomingEventType["DataModelInstructions"] = "DataModelInstructions";
    IncomingEventType["StartNewSpotterConversation"] = "StartNewSpotterConversation";
    IncomingEventType["ResetSpotterConversation"] = "ResetSpotterConversation";
    IncomingEventType["StopSpotterAnswerGeneration"] = "StopSpotterAnswerGeneration";
    IncomingEventType["ShareSpotterConversation"] = "ShareSpotterConversation";
    IncomingEventType["CloseSpotterShareConversation"] = "CloseSpotterShareConversation";
    IncomingEventType["ExitSpotterSharedConversation"] = "ExitSpotterSharedConversation";
    IncomingEventType["DeleteLastPrompt"] = "DeleteLastPrompt";
    IncomingEventType["SpotterVizSendUserMessage"] = "SpotterVizSendUserMessage";
    IncomingEventType["InitSpotterVizConversation"] = "InitSpotterVizConversation";
    IncomingEventType["OpenSpotterVizPanel"] = "OpenSpotterVizPanel";
    IncomingEventType["CloseSpotterVizPanel"] = "CloseSpotterVizPanel";
    IncomingEventType["SetSpotterSidebarExpanded"] = "SetSpotterSidebarExpanded";
    IncomingEventType["Edit"] = "edit";
    IncomingEventType["Save"] = "save";
    IncomingEventType["Pin"] = "pin";
    IncomingEventType["MakeACopy"] = "makeACopy";
    IncomingEventType["DownloadAsXlsx"] = "downloadAsXLSX";
    IncomingEventType["DownloadAsPdf"] = "downloadAsPdf";
    IncomingEventType["DownloadLiveboardAsContinuousPDF"] = "downloadLiveboardAsContinuousPDF";
    IncomingEventType["DownloadAsPng"] = "downloadAsPng";
    IncomingEventType["DownloadAsCsv"] = "downloadAsCSV";
    IncomingEventType["AnswerChartSwitcher"] = "answerChartSwitcher";
    IncomingEventType["VisibleEmbedCoordinates"] = "visibleEmbedCoordinates";
    IncomingEventType["ExitPresentMode"] = "exitPresentMode";
    IncomingEventType["AddToCoaching"] = "addToCoaching";
    IncomingEventType["AskSpotter"] = "AskSpotter";
    IncomingEventType["AIHighlights"] = "AIHighlights";
    IncomingEventType["EmbedDestroyed"] = "EmbedDestroyed";
    IncomingEventType["GetPageContext"] = "GetPageContext";
    IncomingEventType["UpdateEmbedParams"] = "UpdateEmbedParams";
    IncomingEventType["Delete"] = "onDeleteAnswer";
    IncomingEventType["SetActiveTab"] = "SetActiveTab";
    IncomingEventType["SendTestScheduleEmail"] = "sendTestScheduleEmail";
    IncomingEventType["RefreshLiveboardBrowserCache"] = "refreshLiveboardBrowserCache";
})(IncomingEventType || (IncomingEventType = {}));
var HomeLeftNavItems;
(function (HomeLeftNavItems) {
    HomeLeftNavItems["SEARCH_DATA"] = "search-data";
    HomeLeftNavItems["HOME"] = "insights-home";
    HomeLeftNavItems["LIVEBOARDS"] = "liveboards";
    HomeLeftNavItems["ANSWERS"] = "answers";
    HomeLeftNavItems["MONITOR_ALERTS"] = "monitor-alerts";
    HomeLeftNavItems["SPOTIQ_ANALYSIS"] = "spotiq-analysis";
    HomeLeftNavItems["LIVEBOARD_SCHEDULES"] = "liveboard-schedules";
    HomeLeftNavItems["CREATE"] = "create";
    HomeLeftNavItems["SPOTTER"] = "spotter";
})(HomeLeftNavItems || (HomeLeftNavItems = {}));
var HomepageModule;
(function (HomepageModule) {
    HomepageModule["Search"] = "SEARCH";
    HomepageModule["Watchlist"] = "WATCHLIST";
    HomepageModule["Favorite"] = "FAVORITE";
    HomepageModule["MyLibrary"] = "MY_LIBRARY";
    HomepageModule["Trending"] = "TRENDING";
    HomepageModule["Learning"] = "LEARNING";
    HomepageModule["Announcement"] = "ANNOUNCEMENT";
})(HomepageModule || (HomepageModule = {}));
var ListPageColumns;
(function (ListPageColumns) {
    ListPageColumns["Favourite"] = "FAVOURITE";
    ListPageColumns["Tags"] = "TAGS";
    ListPageColumns["Author"] = "AUTHOR";
    ListPageColumns["DateSort"] = "DATE_SORT";
    ListPageColumns["Share"] = "SHARE";
    ListPageColumns["Verified"] = "VERIFIED";
})(ListPageColumns || (ListPageColumns = {}));
var DataSourceVisualMode;
(function (DataSourceVisualMode) {
    DataSourceVisualMode["Hidden"] = "hide";
    DataSourceVisualMode["Collapsed"] = "collapse";
    DataSourceVisualMode["Expanded"] = "expand";
})(DataSourceVisualMode || (DataSourceVisualMode = {}));
var ExportEvents;
(function (ExportEvents) {
    ExportEvents["THOUGHTSPOT_AUTH_EXPIRED"] = "ThoughtspotAuthExpired";
    ExportEvents["EXPORT_VIZ_DATA_TO_PARENT"] = "exportVizDataToParent";
    ExportEvents["ALERT"] = "alert";
    ExportEvents["EXPORT_VIZ_DATA_TO_CHILD"] = "exportVizDataToChild";
    ExportEvents["GET_DATA"] = "getData";
    ExportEvents["GET_EXPORT_REQUEST_FOR_CURRENT_PINBOARD"] = "getExportRequestForCurrentPinboard";
})(ExportEvents || (ExportEvents = {}));
var Action;
(function (Action) {
    Action["AddScenario"] = "addScenario";
    Action["Edit"] = "edit";
    Action["Pin"] = "pin";
    Action["Share"] = "share";
    Action["Save"] = "save";
    Action["EditACopy"] = "editACopy";
    Action["SaveAsView"] = "saveAsView";
    Action["ShowUnderlyingData"] = "showUnderlyingData";
    Action["AnswerDelete"] = "onDeleteAnswer";
    Action["MoveToTab"] = "onContainerMove";
    Action["DownloadAsPng"] = "downloadAsPng";
    Action["DownloadAsCsv"] = "downloadAsCSV";
    Action["DownloadAsPdf"] = "downloadAsPdf";
    Action["DownloadLiveboardAsContinuousPDF"] = "downloadLiveboardAsContinuousPDF";
    Action["DownloadLiveboardAsA4Pdf"] = "downloadLiveboardAsA4Pdf";
    Action["DownloadAsXlsx"] = "downloadAsXLSX";
    Action["DownloadLiveboard"] = "downloadLiveboard";
    Action["DownloadLiveboardAsXlsx"] = "downloadLiveboardAsXlsx";
    Action["DownloadLiveboardAsCsv"] = "downloadLiveboardAsCsv";
    Action["Download"] = "download";
    Action["ReplaySearch"] = "replaySearch";
    Action["SendFeedback"] = "sendFeedback";
    Action["SpotIQAnalyze"] = "spotIQAnalyze";
    Action["CopyAndEdit"] = "context-menu-item-copy-and-edit";
    Action["TML"] = "tml";
    Action["ExportTML"] = "exportTSL";
    Action["EditTML"] = "editTSL";
    Action["EditTokens"] = "editTokens";
    Action["UpdateTML"] = "updateTSL";
    Action["QueryDetailsButtons"] = "queryDetailsButtons";
    Action["Monitor"] = "monitor";
    Action["CreateMonitor"] = "createMonitor";
    Action["CopyLink"] = "embedDocument";
    Action["ManageMonitor"] = "manageMonitor";
    Action["EnableContextualChangeAnalysis"] = "enableContextualChangeAnalysis";
    Action["EnableIterativeChangeAnalysis"] = "enableIterativeChangeAnalysis";
    Action["AnswerChartSwitcher"] = "answerChartSwitcher";
    Action["ToggleSize"] = "toggleSize";
    Action["Explore"] = "explore";
    Action["Present"] = "present";
    Action["Annotate"] = "annotate";
    Action["AddToFavorites"] = "addToFavorites";
    Action["RemoveFromFavorites"] = "removeFromFavorites";
    Action["LiveboardDetails"] = "liveboardDetails";
    Action["Schedule"] = "subscription";
    Action["SendTestScheduleEmail"] = "sendTestScheduleEmail";
    Action["MakeACopy"] = "makeACopy";
    Action["SchedulesList"] = "schedule-list";
    Action["LiveboardInfo"] = "pinboardInfo";
    Action["Remove"] = "delete";
    Action["AddFilter"] = "addFilter";
    Action["LiveboardUsers"] = "liveboardUsers";
    Action["ConfigureFilter"] = "configureFilter";
    Action["ReportError"] = "reportError";
    Action["ReportIssue"] = "reportIssue";
    Action["EditTitle"] = "editTitle";
    Action["EditDetails"] = "editDetails";
    Action["TileSizeSelect"] = "sizeSelect";
    Action["EditTitleDescription"] = "editTitleDescription";
    Action["RenameModalTitleDescription"] = "renameModalTitleDescription";
    Action["ManageSchedules"] = "manageSchedules";
    Action["RequestAccess"] = "requestAccess";
    Action["Sync"] = "sync";
    Action["SyncToSheets"] = "sync-to-sheets";
    Action["SyncToOtherApps"] = "sync-to-other-apps";
    Action["ManagePipelines"] = "manage-pipeline";
    Action["SyncToSlack"] = "syncToSlack";
    Action["SyncToTeams"] = "syncToTeams";
    Action["CollapseDataSources"] = "collapseDataSources";
    Action["CollapseDataPanel"] = "collapseDataPanel";
    Action["AddFormula"] = "addFormula";
    Action["AddParameter"] = "addParameter";
    Action["AddSimpleCohort"] = "addSimpleCohort";
    Action["AddAdvancedCohort"] = "addAdvancedCohort";
    Action["AddDataPanelObjects"] = "addDataPanelObjects";
    Action["ChooseDataSources"] = "chooseDataSources";
    Action["AxisMenuAggregate"] = "axisMenuAggregate";
    Action["AxisMenuTimeBucket"] = "axisMenuTimeBucket";
    Action["AxisMenuFilter"] = "axisMenuFilter";
    Action["AxisMenuConditionalFormat"] = "axisMenuConditionalFormat";
    Action["AxisMenuSort"] = "axisMenuSort";
    Action["AxisMenuGroup"] = "axisMenuGroup";
    Action["AxisMenuPosition"] = "axisMenuPosition";
    Action["AxisMenuRename"] = "axisMenuRename";
    Action["AxisMenuEdit"] = "axisMenuEdit";
    Action["AxisMenuNumberFormat"] = "axisMenuNumberFormat";
    Action["AxisMenuTextWrapping"] = "axisMenuTextWrapping";
    Action["AxisMenuRemove"] = "axisMenuRemove";
    Action["AxisMenuCompare"] = "axisMenuCompare";
    Action["AxisMenuMerge"] = "axisMenuMerge";
    Action["InsertInToSlide"] = "insertInToSlide";
    Action["RequestVerification"] = "requestVerification";
    Action["MarkAsVerified"] = "markAsVerified";
    Action["AddTab"] = "addTab";
    Action["PersonalisedViewsDropdown"] = "personalisedViewsDropdown";
    Action["ShowSageQuery"] = "showSageQuery";
    Action["EditSageAnswer"] = "editSageAnswer";
    Action["SageAnswerFeedback"] = "sageAnswerFeedback";
    Action["ModifySageAnswer"] = "modifySageAnswer";
    Action["ShowVersionHistory"] = "showVersionHistory";
    Action["EnableVersionControl"] = "enableVersionControl";
    Action["DisableVersionControl"] = "disableVersionControl";
    Action["WithdrawVerification"] = "withdrawVerification";
    Action["AskAi"] = "AskAi";
    Action["VerifiedLiveboard"] = "verifiedLiveboard";
    Action["AIHighlights"] = "AIHighlights";
    Action["OrganiseFavourites"] = "organiseFavourites";
    Action["AddToWatchlist"] = "addToWatchlist";
    Action["ManageTags"] = "manageTags";
    Action["RemoveFromWatchlist"] = "removeFromWatchlist";
    Action["ViewLiveboard"] = "viewLiveboard";
    Action["CopyKpiLink"] = "copyKpiLink";
    Action["CreateLiveboard"] = "createLiveboard";
    Action["RenameLiveboard"] = "renameLiveboard";
    Action["FilterPanelToggle"] = "filterPanelToggle";
    Action["EditScheduleHomepage"] = "editScheduleHomepage";
    Action["PauseScheduleHomepage"] = "pauseScheduleHomepage";
    Action["ViewScheduleRunHomepage"] = "viewScheduleRunHomepage";
    Action["UnsubscribeScheduleHomepage"] = "unsubscribeScheduleHomepage";
    Action["DeleteScheduleHomepage"] = "deleteScheduleHomepage";
    Action["KPIAnalysisCTA"] = "kpiAnalysisCTA";
    Action["DisableChipReorder"] = "disableChipReorder";
    Action["ChangeFilterVisibilityInTab"] = "changeFilterVisibilityInTab";
    Action["SwitchToNewChartExperience"] = "switchToNewChartExperience";
    Action["SwitchToClassicChartExperience"] = "switchToClassicChartExperience";
    Action["CoverAndFilterOptionInPDF"] = "coverAndFilterOptionInPDF";
    Action["PngScreenshotInEmail"] = "pngScreenshotInEmail";
    Action["RemoveAttachment"] = "removeAttachment";
    Action["ColumnRename"] = "columnRename";
    Action["SpotterWarningsBanner"] = "SpotterWarningsBanner";
    Action["SpotterWarningsOnTokens"] = "SpotterWarningsOnTokens";
    Action["SpotterTokenQuickEdit"] = "SpotterTokenQuickEdit";
    Action["SpotterChatRename"] = "spotterChatRename";
    Action["SpotterChatDelete"] = "spotterChatDelete";
    Action["SpotterShareConversationButtonHeader"] = "spotterShareConversationButtonHeader";
    Action["SpotterShareConversationMenuItemSidebar"] = "spotterShareConversationMenuItemSidebar";
    Action["SpotterSharedConversationBanner"] = "spotterSharedConversationBanner";
    Action["SpotterSharedConversationBannerDismissButton"] = "spotterSharedConversationBannerDismissButton";
    Action["SpotterSharedConversationExitButton"] = "spotterSharedConversationExitButton";
    Action["SpotterShareUpToCurrentInfo"] = "spotterShareUpToCurrentInfo";
    Action["SpotterShareIncludeNewMessagesCheckbox"] = "spotterShareIncludeNewMessagesCheckbox";
    Action["SpotterShareStaleInfoBannerDismissButton"] = "spotterShareStaleInfoBannerDismissButton";
    Action["SpotterChatMenu"] = "spotterChatMenu";
    Action["SpotterNewChat"] = "spotterNewChat";
    Action["SpotterSidebarToggle"] = "spotterSidebarToggle";
    Action["SpotterDocs"] = "spotterDocs";
    Action["SpotterSidebarHeader"] = "spotterSidebarHeader";
    Action["SpotterSidebarFooter"] = "spotterSidebarFooter";
    Action["SpotterPastChatBanner"] = "spotterPastChatBanner";
    Action["SpotterChatConnectorResources"] = "spotterChatConnectorResources";
    Action["SpotterChatConnectors"] = "spotterChatConnectors";
    Action["SpotterChatModeSwitcher"] = "spotterChatModeSwitcher";
    Action["InConversationTraining"] = "InConversationTraining";
    Action["SpotterViz"] = "spotterViz";
    Action["SpotterVizFeedback"] = "spotterVizFeedback";
    Action["SpotterVizCheckpointRestore"] = "spotterVizCheckpointRestore";
    Action["SpotterVizReferenceMode"] = "spotterVizReferenceMode";
    Action["Publish"] = "publish";
    Action["ManagePublishing"] = "managePublishing";
    Action["Unpublish"] = "unpublish";
    Action["Parameterise"] = "parameterise";
    Action["LiveboardStylePanel"] = "liveboardStylePanel";
    Action["MoveToGroup"] = "moveToGroup";
    Action["MoveOutOfGroup"] = "moveOutOfGroup";
    Action["CreateGroup"] = "createGroup";
    Action["UngroupLiveboardGroup"] = "ungroupLiveboardGroup";
    Action["IncludeCurrentPeriod"] = "includeCurrentPeriod";
    Action["GetExportRequestForCurrentPinboard"] = "getExportRequestForCurrentPinboard";
    Action["RefreshLiveboardBrowserCache"] = "refreshLiveboardBrowserCache";
    Action["SpotterAnalystShare"] = "spotterAnalystShare";
    Action["SpotterAnalystEdit"] = "spotterAnalystEdit";
    Action["SpotterAnalystCreate"] = "spotterAnalystCreate";
    Action["SpotterAnalystDelete"] = "spotterAnalystDelete";
    Action["SpotterAnalystMakeACopy"] = "spotterAnalystMakeACopy";
    Action["SpotterAnalystSidebar"] = "spotterAnalystSidebar";
    Action["AddToCollection"] = "addToCollection";
    Action["CreateCollection"] = "createCollection";
    Action["MoveToCollection"] = "moveToCollection";
    Action["RemoveFromCollection"] = "removeFromCollection";
    Action["DeleteCollection"] = "deleteCollection";
    Action["EditInputTable"] = "editInputTable";
})(Action || (Action = {}));
var DispatchAction;
(function (DispatchAction) {
    DispatchAction["CrossFilterModified"] = "Cross filter added/updated";
    DispatchAction["CrossFilterRemoved"] = "Cross filter removed";
    DispatchAction["AllCrossFilterRemoved"] = "All the cross filters removed";
})(DispatchAction || (DispatchAction = {}));
var EmbedUrlsEnum;
(function (EmbedUrlsEnum) {
    EmbedUrlsEnum["PINBOARD_URL"] = "PINBOARD_URL";
    EmbedUrlsEnum["PINBOARD_VIZ_URL"] = "PINBOARD_VIZ_URL";
    EmbedUrlsEnum["ANSWER_URL"] = "ANSWER_URL";
    EmbedUrlsEnum["INSIGHT_URL"] = "INSIGHT_URL";
    EmbedUrlsEnum["UNSUBSCRIBE_URL"] = "UNSUBSCRIBE_URL";
    EmbedUrlsEnum["GENERIC_URL"] = "GENERIC_URL";
})(EmbedUrlsEnum || (EmbedUrlsEnum = {}));
var eventErrorType;
(function (eventErrorType) {
    eventErrorType["Api"] = "API";
    eventErrorType["Fullscreen"] = "FULLSCREEN";
    eventErrorType["SingleValueFilter"] = "SINGLE_VALUE_FILTER";
    eventErrorType["NonExistFilter"] = "NON_EXIST_FILTER";
    eventErrorType["NoActivePersonalisedViewsError"] = "NO_ACTIVE_PERSONALISED_VIEWS_ERROR";
    eventErrorType["PersonalisedViewNotFound"] = "PERSONALISED_VIEW_NOT_FOUND";
    eventErrorType["InvalidDateValue"] = "INVALID_DATE_VALUE";
    eventErrorType["InvalidOperator"] = "INVALID_OPERATOR";
    eventErrorType["WrongVizId"] = "WRONG_VIZ_ID";
    eventErrorType["NotAWorksheet"] = "NOT_A_WORKSHEET";
    eventErrorType["NoFilterableColumnPresent"] = "NO_FILTERABLE_COLUMN_PRESENT";
    eventErrorType["filterExistsOrNoAttributeColumn"] = "FILTER_EXISTS_OR_NO_ATTRIBUTE_COLUMN";
    eventErrorType["InvalidColumnId"] = "INVALID_COLUMN_ID";
    eventErrorType["ValidationError"] = "VALIDATION_ERROR";
    eventErrorType["CONV_ASSIST_ERROR"] = "CONV_ASSIST_ERROR";
    eventErrorType["GENERIC_ERROR"] = "GENERIC_ERROR";
    eventErrorType["TIMEOUT_ERROR"] = "TIMEOUT_ERROR";
    eventErrorType["CONVEX_ERROR"] = "CONVEX_ERROR";
})(eventErrorType || (eventErrorType = {}));
var embedErrorCodes;
(function (embedErrorCodes) {
    embedErrorCodes["CUSTOM_ACTION_FILTER_VALIDATION"] = "CUSTOM_ACTION_FILTER_VALIDATION";
    embedErrorCodes["ANSWER_CONTEXT_ACTION_FILTER_VALIDATION"] = "ANSWER_CONTEXT_ACTION_FILTER_VALIDATION";
    embedErrorCodes["PINBOARD_ACTION_FILTER_VALIDATION"] = "PINBOARD_ACTION_FILTER_VALIDATION";
    embedErrorCodes["SPOTTER_ACTION_FILTER_VALIDATION"] = "SPOTTER_ACTION_FILTER_VALIDATION";
    embedErrorCodes["VIZ_ACTION_FILTER_VALIDATION"] = "VIZ_ACTION_FILTER_VALIDATION";
    embedErrorCodes["UPDATE_EMBED_FILTERS_VALIDATION"] = "UPDATE_EMBED_FILTERS_VALIDATION";
    embedErrorCodes["PRESENT_MODE_FULLSCREEN_ERROR"] = "PRESENT_MODE_FULLSCREEN_ERROR";
    embedErrorCodes["UPDATE_EMBED_CROSS_FILTERS_VALIDATION"] = "UPDATE_EMBED_CROSS_FILTERS_VALIDATION";
    embedErrorCodes["UPDATE_EMBED_SEARCH_COLUMN_VALIDATION"] = "UPDATE_EMBED_SEARCH_COLUMN_VALIDATION";
    embedErrorCodes["HOST_EVENT_VALIDATION"] = "HOST_EVENT_VALIDATION";
    embedErrorCodes["GRAPHQL_API_ERRORS"] = "GRAPHQL_API_ERRORS";
    embedErrorCodes["CONV_ASSIST_ERROR"] = "CONV_ASSIST_ERROR";
    embedErrorCodes["CREATE_CONVERSATION_ERROR"] = "CREATE_CONVERSATION_ERROR";
    embedErrorCodes["UPDATE_CONVERSATION_CONTEXT_ERROR"] = "UPDATE_CONVERSATION_CONTEXT_ERROR";
    embedErrorCodes["SEND_CONVERSATION_MESSAGE_ERROR"] = "SEND_CONVERSATION_MESSAGE_ERROR";
    embedErrorCodes["EDIT_CONVERSATION_MESSAGE_ERROR"] = "EDIT_CONVERSATION_MESSAGE_ERROR";
    embedErrorCodes["RETRY_CONVERSATION_MESSAGE_ERROR"] = "RETRY_CONVERSATION_MESSAGE_ERROR";
    embedErrorCodes["DELETE_CONVERSATION_MESSAGE_ERROR"] = "DELETE_CONVERSATION_MESSAGE_ERROR";
    embedErrorCodes["SEND_CONVERSATION_MESSAGE_FEEDBACK_ERROR"] = "SEND_CONVERSATION_MESSAGE_FEEDBACK_ERROR";
    embedErrorCodes["UPDATE_CONVERSATION_MESSAGE_ERROR"] = "UPDATE_CONVERSATION_MESSAGE_ERROR";
})(embedErrorCodes || (embedErrorCodes = {}));
var EventStatus;
(function (EventStatus) {
    EventStatus["Start"] = "start";
    EventStatus["End"] = "end";
})(EventStatus || (EventStatus = {}));
const filterParam = {
    columnName: optional('string'),
    columnId: optional('string'),
    operator: optional('string'),
    values: requiredArrayOf('string'),
    type: optional('string'),
    datePeriod: optional('string'),
    negate: optional('boolean'),
    column: optional('string'),
    oper: optional('string'),
};
const EventType = blinkConstants.embedEvents;
const allowedHostEvents = {
    ...Action,
    ...IncomingEventType,
};
export const HostEventContract = {
    [IncomingEventType.OpenFilter]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            column: objectOf({
                columnId: optional('string'),
                columnName: optional('string'),
            }),
            visualizationId: optional('string'),
            liveboardId: optional('string'),
        }),
        [HostEventContexts.SPOTTER]: objectOf({
            column: objectOf({
                columnId: optional('string'),
                columnName: optional('string'),
            }),
        }),
        [HostEventContexts.SEARCH]: objectOf({
            column: objectOf({
                columnId: required('string'),
                columnName: optional('string'),
                type: required('string'),
                dataType: required('string'),
                name: required('string'),
                isStrictDateColumn: optional('boolean'),
            }),
        }),
    },
    [IncomingEventType.AddColumns]: {
        [HostEventContexts.SEARCH]: objectOf({
            columnIds: arrayOf('string'),
        }),
    },
    [IncomingEventType.RemoveColumn]: {
        [HostEventContexts.SEARCH]: objectOf({
            columnId: required('string'),
        }),
    },
    [IncomingEventType.Navigate]: {
        [HostEventContexts.OTHER]: oneOf([
            objectOf({
                path: required('string'),
                replace: optional('boolean'),
            }),
            required('string'),
            required('number'),
        ]),
    },
    [IncomingEventType.Edit]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.DownloadAsPng]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.DownloadAsCsv]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.DownloadAsXlsx]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.DownloadAsPdf]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
            liveboardId: optional('string'),
        }),
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.SetVisibleTabs]: {
        [HostEventContexts.LIVEBOARD]: arrayOf('string'),
    },
    [IncomingEventType.SetHiddenTabs]: {
        [HostEventContexts.LIVEBOARD]: arrayOf('string'),
    },
    [IncomingEventType.SetVisibleVizs]: {
        [HostEventContexts.LIVEBOARD]: arrayOf('string'),
    },
    [IncomingEventType.UpdatePersonalisedView]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            viewId: optional('string'),
        }),
    },
    [IncomingEventType.SelectPersonalisedView]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            viewId: optional('string'),
            viewName: optional('string'),
        }),
    },
    [IncomingEventType.ResetLiveboardPersonalisedView]: {
        [HostEventContexts.LIVEBOARD]: voidParam('No parameters expected'),
    },
    [IncomingEventType.Search]: {
        [HostEventContexts.SEARCH]: objectOf({
            searchQuery: required('string'),
            dataSources: arrayOf('string'),
            execute: optional('boolean'),
        }),
    },
    [IncomingEventType.ResetSearch]: {
        [HostEventContexts.SEARCH]: voidParam('No parameters expected'),
    },
    [IncomingEventType.AskSage]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.AskSpotter]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.AIHighlights]: {
        [HostEventContexts.LIVEBOARD]: voidParam('No parameters expected'),
    },
    [IncomingEventType.SpotterSearch]: {
        [HostEventContexts.SPOTTER]: objectOf({
            query: required('string'),
            executeSearch: required('boolean'),
        }),
    },
    [IncomingEventType.ResetSpotterConversation]: {
        [HostEventContexts.SPOTTER]: voidParam('No parameters expected'),
    },
    [IncomingEventType.StopSpotterAnswerGeneration]: {
        [HostEventContexts.SPOTTER]: voidParam('No parameters expected'),
    },
    [IncomingEventType.ShareSpotterConversation]: {
        [HostEventContexts.SPOTTER]: objectOf({
            conversationId: required('string'),
        }),
    },
    [IncomingEventType.CloseSpotterShareConversation]: {
        [HostEventContexts.SPOTTER]: voidParam('No parameters expected'),
    },
    [IncomingEventType.ExitSpotterSharedConversation]: {
        [HostEventContexts.SPOTTER]: voidParam('No parameters expected'),
    },
    [IncomingEventType.EditLastPrompt]: {
        [HostEventContexts.SPOTTER]: required('string'),
    },
    [IncomingEventType.DeleteLastPrompt]: {
        [HostEventContexts.SPOTTER]: voidParam('No parameters expected'),
    },
    [IncomingEventType.SetSpotterSidebarExpanded]: {
        [HostEventContexts.SPOTTER]: objectOf({
            expanded: required('boolean'),
        }),
    },
    [IncomingEventType.PreviewSpotterData]: {
        [HostEventContexts.SPOTTER]: voidParam('No parameters expected'),
    },
    [IncomingEventType.SpotterVizSendUserMessage]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            query: required('string'),
        }),
    },
    [IncomingEventType.InitSpotterVizConversation]: {
        [HostEventContexts.LIVEBOARD]: voidParam('No parameters expected'),
    },
    [IncomingEventType.OpenSpotterVizPanel]: {
        [HostEventContexts.LIVEBOARD]: voidParam('No parameters expected'),
    },
    [IncomingEventType.CloseSpotterVizPanel]: {
        [HostEventContexts.LIVEBOARD]: voidParam('No parameters expected'),
    },
    [IncomingEventType.AnswerChartSwitcher]: {
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.Drilldown]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            points: objectOf({
                clickedPoint: required('object'),
                selectedPoints: requiredArrayOf('object'),
            }),
            columnGuid: optional('string'),
            autoDrillDown: optional('boolean'),
            vizId: required('string'),
        }),
        [HostEventContexts.SEARCH]: objectOf({
            points: objectOf({
                clickedPoint: required('object'),
                selectedPoints: requiredArrayOf('object'),
            }),
            columnGuid: optional('string'),
            autoDrillDown: optional('boolean'),
            vizId: optional('string'),
        }),
    },
    [IncomingEventType.Delete]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [IncomingEventType.GetAnswerSession]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.GetParameters]: {
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.GetTML]: {
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.Save]: {
        [HostEventContexts.SPOTTER]: objectOf({
            vizId: required('string'),
        }),
    },
    [IncomingEventType.SetActiveTab]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            tabId: required('string'),
        }),
    },
    [IncomingEventType.UpdateCrossFilter]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
            conditions: requiredArrayOf(objectOf({
                columnName: optional('string'),
                values: arrayOf('string'),
                operator: optional('string'),
            })),
        }),
    },
    [IncomingEventType.UpdateFilters]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            filter: optionalObjectOf(filterParam),
            filters: optionalArrayOf(objectOf(filterParam)),
        }),
    },
    [IncomingEventType.UpdateParameters]: {
        [HostEventContexts.LIVEBOARD]: requiredArrayOf(objectOf({
            name: required('string'),
            value: required('string'),
            isVisibleToUser: optional('boolean'),
        })),
    },
    [IncomingEventType.UpdateRuntimeFilters]: {
        [HostEventContexts.LIVEBOARD]: requiredArrayOf(objectOf({
            columnName: required('string'),
            operator: required('string'),
            values: arrayOf('string'),
        })),
    },
    [IncomingEventType.SendTestScheduleEmail]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            sendToSelf: optional('boolean'),
        }),
    },
    [IncomingEventType.RefreshLiveboardBrowserCache]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            sendToSelf: optional('boolean'),
        }),
    },
    [Action.Share]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.Present]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.OTHER]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.CopyLink]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.ExportTML]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.EditTML]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.UpdateTML]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.SchedulesList]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.Schedule]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.Explore]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
        }),
    },
    [Action.SpotIQAnalyze]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.ShowUnderlyingData]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.CreateMonitor]: {
        [HostEventContexts.LIVEBOARD]: objectOf({
            vizId: required('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.ManageMonitor]: {
        [HostEventContexts.LIVEBOARD]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.Sync]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
        [HostEventContexts.ANSWER]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.SyncToSheets]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.SyncToOtherApps]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
    [Action.ManagePipelines]: {
        [HostEventContexts.SEARCH]: optionalObjectOf({
            vizId: optional('string'),
        }),
    },
};
export { HomePageSearchBarMode, EmbedEventConstants, IncomingEventType, HomeLeftNavItems, HomepageModule, DataSourceVisualMode, ExportEvents, Action, DispatchAction, EmbedUrlsEnum, eventErrorType, embedErrorCodes, EventStatus, EventType, ListPageColumns, allowedHostEvents, };
//# sourceMappingURL=index.js.map